/**
 * لیست بسترهای داخلی (native platforms)
 */
export const NATIVE_PLATFORMS = ['eitaa', 'bale', 'rubika'];

export const isNativePlatform = ({
  platform,
  shouldIncludeNativePlatforms = false,
}) =>
  NATIVE_PLATFORMS.includes(platform) ||
  (shouldIncludeNativePlatforms && platform === 'nativePlatforms');

/**
 * تبدیل لیست پلتفرم‌ها به لیست کامل (تبدیل nativePlatforms به بسترهای جداگانه)
 * @param {string[]} sortedPlatforms - لیست پلتفرم‌های مرتب شده
 * @returns {string[]} - لیست پلتفرم‌های کامل شده
 */
export const expandPlatformsList = (sortedPlatforms) => {
  return sortedPlatforms.flatMap((platform) => {
    if (platform === 'nativePlatforms') {
      return NATIVE_PLATFORMS;
    }
    return [platform];
  });
};
